goog.module('yext.developerapps.olomenusyncing.OloMenuSyncingAccountConfiguration');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.developerapps.routes');
const Field = goog.require('yext.developerapps.olomenusyncing.Field');

const OloMenuSyncingAccountConfiguration = class
  extends Field {
  constructor() {
    super($('.js-olomenusyncing-api-key-container'));
  }

  /** @override */
  doSubmit_(data) {
    return $.ajax({
      method: 'POST',
      url: routes.OloMenuSyncing.saveConfiguration(),
      data: data,
    })
      .done(function(resp) {
        if (resp['success']) {
          window.location.href = routes.OloMenuSyncing.apiKey();
        } else if (resp['errors']) {
          this.handleErrors_(resp['errors']);
        } else if (resp['error']) {
          this.showGenericError_(resp['error']);
        } else {
          this.showGenericError_('Error saving configuration.');
        }
      }.bind(this));
  }
};

goog.exportSymbol('yext.developerapps.olomenusyncing.OloMenuSyncingAccountConfiguration',
  OloMenuSyncingAccountConfiguration);

exports = OloMenuSyncingAccountConfiguration;
